import { render, staticRenderFns } from "./TrialAlert.vue?vue&type=template&id=6c5840ef&scoped=true"
import script from "./TrialAlert.vue?vue&type=script&lang=js"
export * from "./TrialAlert.vue?vue&type=script&lang=js"
import style0 from "./TrialAlert.vue?vue&type=style&index=0&id=6c5840ef&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5840ef",
  null
  
)

export default component.exports